import React, { useState } from 'react'

import './styles.css'
import ContactForm from './components/ContactForm'
import Disclaimer from './components/Disclaimer'
import { EResult } from './components/ContactForm/components/Result'
import VariantWrapper from '../VariantWrapper'
import { variants } from '../../constants/variant'
import Modal from '../Modal'
import { getTermsOfUse } from '../../helpers/termsOfUse'
import { getPrivacyPolicy } from '../../helpers/privacyPolicy'
import { useStore } from '../../store'

function Sidebar({ className = '', onToggle = () => { }, onTransitionEnd = () => { }, onFormResult }) {
  const [openModal, setOpenModal] = useState(null)
  const { config } = useStore()
  const termsOfUse = getTermsOfUse(config?.variant)
  const privacyPolicy = getPrivacyPolicy(config?.variant)

  const handleOpenModal = (type) => (e) => {
    e.preventDefault()
    setOpenModal(type)
  }

  const handleCloseModal = () => {
    setOpenModal(null)
  }

  return (
    <div
      onTransitionEnd={onTransitionEnd}
      id="sidebar"
      className={`w-[var(--sidebar-width)] max-h-[screen] overflow-y-auto relative z-[400] shadow-xl flex-shrink-0 bg-white pb-[16px] px-[24px] border-l-[1px] border-solid border-[#C7CCD9] flex flex-col justify-between ${className}`}
    >
      <div>
        <ContactForm
          onResult={onFormResult}
          onClose={(result) => {
            if (result === EResult.SUCCESS) {
              onToggle(false)
            }
          }}
        />
      </div>
      <VariantWrapper show={[variants.av]}>
        <div className='text-[12px] leading-[18px] text-[#3D4256] text-center' id='avalon-sidebar-footer'>
          <a
            href="#"
            onClick={handleOpenModal('terms')}
            className="hover:underline transition-colors cursor-pointer"
          >
            Terms of Use
          </a>
          {' · '}
          <a
            href="#"
            onClick={handleOpenModal('privacy')}
            className="hover:underline transition-colors cursor-pointer"
          >
            Privacy Policy
          </a>
        </div>
      </VariantWrapper>

      {openModal === 'privacy' && (
        <Modal onClose={handleCloseModal}>
          <div className="max-w-[600px] max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-[#3D4256]">{privacyPolicy?.title || 'Privacy Policy'}</h2>
              <button
                onClick={handleCloseModal}
                className="text-[#3D4256] hover:text-[#1a1d2e] text-2xl leading-none"
              >
                ×
              </button>
            </div>
            <div className="text-[#3D4256] space-y-4 text-sm leading-relaxed">
              {privacyPolicy?.content}
            </div>
          </div>
        </Modal>
      )}

      {openModal === 'terms' && (
        <Modal onClose={handleCloseModal}>
          <div className="max-w-[600px] max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-[#3D4256]">Terms of Use</h2>
              <button
                onClick={handleCloseModal}
                className="text-[#3D4256] hover:text-[#1a1d2e] text-2xl leading-none"
              >
                ×
              </button>
            </div>
            <div className="text-[#3D4256] space-y-4 text-sm leading-relaxed">
              {termsOfUse?.content}
            </div>
          </div>
        </Modal>
      )}
    </div>
  )
}

export default Sidebar
